import { useState } from "react";
import { cardImageUrl } from "@/lib/api";
import { ImageOff } from "lucide-react";

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

const TONES = {
  coral: { color: "#FF4438", bg: "rgba(255,68,56,.12)", border: "rgba(255,68,56,.4)" },
  amber: { color: "#fbbf24", bg: "rgba(245,158,11,.12)", border: "rgba(245,158,11,.45)" },
  gray: { color: "rgba(255,255,255,.6)", bg: "rgba(255,255,255,.04)", border: "rgba(255,255,255,.14)" },
  green: { color: "#34D399", bg: "rgba(52,211,153,.10)", border: "rgba(52,211,153,.4)" },
};

const BADGES = {
  coral: { background: "rgba(255,68,56,.14)", color: "#ff8a80", border: "1px solid rgba(255,68,56,.5)" },
  amber: { background: "rgba(245,158,11,.12)", color: "#fbbf24", border: "1px solid rgba(245,158,11,.5)" },
  green: { background: "rgba(52,211,153,.10)", color: "#34D399", border: "1px solid rgba(52,211,153,.45)" },
  turbo: { background: "#34D399", color: "#080808", border: "1px solid #34D399" },
  gray: { background: "rgba(255,255,255,.06)", color: "rgba(255,255,255,.7)", border: "1px solid rgba(255,255,255,.2)" },
};

export const GLOW = { coral: "rgba(255,68,56,.28)", green: "rgba(52,211,153,.28)", amber: "rgba(245,158,11,.28)", gray: "rgba(255,255,255,.06)" };

export function Badge({ tone = "coral", children, testid, className = "" }) {
  return (
    <span data-testid={testid} style={BADGES[tone]}
          className={`sx-mono inline-flex items-center gap-1.5 text-[10px] tracking-[.1em] uppercase px-2.5 py-1.5 rounded-full leading-none ${className}`}>
      {children}
    </span>
  );
}

export function ClockPill({ tone = "coral", children, testid, className = "" }) {
  const t = TONES[tone];
  return (
    <span data-testid={testid} style={{ color: t.color, background: t.bg, border: `1px solid ${t.border}` }}
          className={`sx-mono inline-block text-[15px] px-2.5 py-[7px] rounded-[10px] leading-none whitespace-nowrap ${className}`}>
      {children}
    </span>
  );
}

export function Label({ children, className = "", ...rest }) {
  return <div className={`sx-label ${className}`} {...rest}>{children}</div>;
}

// Titular con palabra de contrapunto: el último token con número va en itálica.
export function SplitTitle({ text = "", className = "", testid }) {
  const parts = text.trim().split(/\s+/);
  const last = parts.length > 1 && /\d/.test(parts[parts.length - 1]) ? parts.pop() : null;
  return (
    <h1 className={`sx-h ${className}`} data-testid={testid}>
      {parts.join(" ")}{last && <> <span className="sx-it">{last}</span></>}
    </h1>
  );
}

export function CardPhoto({ path, alt, glow = "coral", w = 104, h = 146, size = 600, rotate = -4 }) {
  const [failed, setFailed] = useState(false);
  return (
    <div style={{ width: w, height: h, transform: `rotate(${rotate}deg)`, boxShadow: `0 20px 40px rgba(0,0,0,.6), 0 0 40px ${GLOW[glow]}` }}
         className="rounded-[9px] overflow-hidden border border-white/20 bg-[#1b1b1b] flex items-center justify-center flex-none">
      {path && !failed ? (
        <img src={cardImageUrl(path, size)} alt={alt} loading="lazy" onError={() => setFailed(true)} className="w-full h-full object-cover" />
      ) : <ImageOff size={20} className="text-neutral-600" />}
    </div>
  );
}

export function stageBg(glow) {
  return { background: `radial-gradient(circle at 50% 60%, ${GLOW[glow]}, transparent 60%), #0d0d0d` };
}
